import styled, { css } from "styled-components";

export const ConnectModalWrapper = styled.div`
    padding-top: 10px;
    position: relative;
`;

export const StyledModal = styled.div`
    width: 900px;
    max-width: 100%;
    ${p =>
        p.theme.sm.max(css`
            width: auto;
            margin: auto;
        `)}
    text-align: center;
    ol {
        padding-left: 0;
        margin: 0;
        display: flex;
        ${p =>
        p.theme.sm.max(css`
                flex-direction: column;
                align-items: center;
            `)}
    }
    li {
        text-align: center;
        counter-increment: li;
        list-style: none;
        margin-bottom: 12px;
        flex: 1;
        padding: 0 6px;

        &::before {
            content: counter(li);
            color: ${p => p.theme.c.white};
            background-color: ${p => p.theme.c.active};
            border-radius: 30px;
            width: 40px;
            height: 40px;
            display: inline-block;
            font-size: 30px;

            margin: auto;
            margin-bottom: 4px;
        }
    }

    table {
        margin: 4px auto;
        color: ${p => p.theme.c.pale};
        font-size: 17px;

        td {
            width: 100px;
        }
        thead {
            text-align: center;
        }
    }

    h3 {
        margin: 0;
        color: ${p => p.theme.c.active};
    }

    h2 {
        margin: 6px 0;
        color: ${p => p.theme.c.info};

        &.h2-url {
            font-size: 22px;
        }
    }

    button {
        max-width: 230px;
    }
    ${p => p.theme.md.min(css`
        .LastStep {
            margin-top: -100px;
        }

        .Width-66p {
            width: 66.66%;
            text-transform: uppercase;
        }
        .StepInvisible {
            visibility: hidden;
        }
        .Lastly {
            display: none;
        }
    `)}

    ${p => p.theme.sm.max(css`
        .StepInvisible {
            display: none;
        }
        .Lastly {
            width: 100%;
            margin: 12px 0 22px;
        }
        .Width-66p {
            margin-bottom: 22px;
        }
    `)}

    b {
        color: ${p => p.theme.c.info};
    }
    ${p => p.theme.md.min(css`
        .WithoutNumber:before {
            display: none;
        }
    `)}
`;

export const StudentsList = styled.p`
    font-size: 18px;
    height: 50px;
    color: ${p => p.theme.c.disabled};
    margin: 8px 0;
`;

export const CardWrapper = styled.div`
    ${p =>
        p.theme.md.min(css`
            width: 400px;
            height: 300px;
        `)}
    ${p =>
        p.theme.sm.max(css`
            width: 235px;
        `)}
    > div > div > svg {
        ${p =>
        p.theme.md.min(css`
                height: 200px !important;
            `)}
        ${p =>
        p.theme.sm.max(css`
                width: 235px;
            `)}
    }
    margin: auto;
    margin-bottom: -32px;

    text-align: left;
    padding-bottom: 36px;
    h3 {
        color: ${p => p.theme.c.black};
    }

`;

export const ClassForm = styled.div`
    text-align: left;
    margin-top: 12px;
`;

export const Buttons = styled.div`
    display: flex;
    justify-content: space-between;

    button {
        min-width: 120px;
        margin-bottom: 0;
    }
`;

export const SelectWrapper = styled.div`

`;
